import styled from "styled-components";
import RoundedCard from "../../components/RoundedCard";
import { flags } from "../../featureFlags";
import { routes } from "../../routes";

const ScrollableTabs = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    grid-auto-rows: 1fr;
    grid-gap: 32px;
`;

const Dashboard = () => {
  return (
    <ScrollableTabs>
      <RoundedCard
        title="Discover DataDesc"
        description="Read through the schema documentation"
        icon="logo_github.svg"
        linkTo={routes.schema.absolute}
        disable={!flags.schema}
      />
      <RoundedCard
        title="Generate General Metadata"
        description="Fill out a form and generate general metadata"
        icon="logo_code.svg"
        linkTo={routes.annotationGeneral.absolute}
        disable={!flags.annotationGeneral}
      />
      <RoundedCard
        title="Generate Technical Metadata"
        description="Upload your python script and create a DataDesc metadata sheet"
        icon="logo_code.svg"
        linkTo={routes.annotationTechnical.absolute}
        disable={!flags.annotationTechnical}
      />
      <RoundedCard
        title="Compare Metadata"
        description="Upload two DataDesc metadata sheets and show compatibility"
        icon="logo_code.svg"
        linkTo={routes.compareMetadata.absolute}
        disable={true}
        tooltip="Coming soon"
      />
      <RoundedCard
        title="Merge Metadata"
        description="Merge general and technical metadata into one DataDesc sheet"
        icon="logo_code.svg"
        linkTo={routes.mergeMetadata.absolute}
        disable={!flags.mergeMetadata}
      />
      <RoundedCard
        title="Publish to GitHub"
        description="Create a GitHub repository from your metadata sheet."
        icon="../logo_github.svg"
        linkTo={routes.publishGitHub.absolute}
        disable={!flags.publishGitHub}
      />
    </ScrollableTabs>
  );
};

export default Dashboard;
